import { GoogleAdsLanguageGq } from '../../../../../../../../graphql/projects/models/GoogleAdsLanguageGq';
import { GoogleAdsLocationGq } from '../../../../../../../../graphql/projects/models/GoogleAdsLocationGq';
import { GoogleAdsRequestTypeGq } from '../../../../../../../../graphql/projects/models/GoogleAdsRequestTypeGq';
import { GoogleAdsRequestTagInputGq } from '../../../../../../../../graphql/projects/mutations/googleAds/useCreateGoogleAdsRequestGq';

export interface CreateSearchFormState {
  requestName: string;
  requestType: GoogleAdsRequestTypeGq | null;
  country?: GoogleAdsLocationGq;
  city?: GoogleAdsLocationGq;
  language?: GoogleAdsLanguageGq;
  includeZeroVolume: boolean;
  includeMonths: boolean;
  includeRankData: boolean;
  source: string;
  suggestionsWord?: boolean;
  suggestionsAlphabeticals?: boolean;
  suggestionsNumbers?: boolean;
  suggestionsQuestions?: boolean;
  suggestionsComparisons?: boolean;
  suggestionsPrepositions?: boolean;
  includeTagKeywords?: boolean;
  tagKeywords?: GoogleAdsRequestTagInputGq;
  maxCharacters?: number;
}

export const SearchRequestTypes = [
  {
    type: GoogleAdsRequestTypeGq.EXACT,
    name: 'Exact Keywords',
    searchHistoryName: 'Exact keywords',
    shortDescription: 'Adds the exact list of keywords that you provide',
    placeholder: 'keyword A, keyword B...',
    basic: true,
  },
  {
    // Description: For words or phrases that describe what you're advertising, use KeywordSeed. This could be a general type of business you are targeting such as plumbers, or it could be a product or service you offer such as drain cleaning.
    type: GoogleAdsRequestTypeGq.RELATED,
    name: 'Keyword Ideas',
    searchHistoryName: 'Keyword ideas',
    shortDescription: 'Adds keywords related to the keywords that you provide',
    moreDescription: " (i.e. Google Ads suggests keywords that it considers related to the ones that you provide, max 1000 keywords per seed).",
    placeholder: 'keyword A, keyword B...',
    basic: true,
  },
  {
    // Description: Crawls an URL in order to generate keyword ideas. 
    // Recommended use: For the URL of a webpage or entire website related to your business, use UrlSeed. 
    // Limitations: The URL seed targets only a specific URL. If there are no hits, the search automatically expands up to the pages from the same domain.
    type: GoogleAdsRequestTypeGq.URL,
    name: 'URL Ideas',
    searchHistoryName: 'Url ideas',
    shortDescription: 'Adds keywords related to the URLs that you provide',
    moreDescription: " (i.e. Google Ads crawls the url in order to get keyword ideas, max 1000 keywords per seed).",
    placeholder: 'www.example.com/coconuts, www.example.com/oranges...',
    basic: true,
  },
  {
    // Description: Crawls an entire site in order to generate keyword ideas. 
    // Recommended use: For an entire site, use SiteSeed. Given a top-level domain name, such as www.example.com, the site seed generates up to 250,000 keyword ideas from publicly available information. 
    // Limitations: If the customer requesting the ideas doesn't own the site provided only public information is returned.
    type: GoogleAdsRequestTypeGq.SITE,
    name: 'Domain Ideas',
    searchHistoryName: 'Domain ideas',
    shortDescription: 'Adds keywords related to the domain that you provide',
    moreDescription: " (i.e. Google Ads crawls the entire site in order to get keyword ideas, max 25 000 keywords).",
    placeholder: 'www.example.com',
    basic: true,
  },
  {
    // Description: Keyword Tool will help you discover thousands of new long-tail keywords related to any topic by automatically generating Google's search suggestions.
    // Description: uses Google Autocomplete to generate hundreds of relevant long-tail keywords for any topic. Google Autocomplete is a feature used in Google Search. 
    // Description: To generate long-tail keyword suggestions, Keyword Tool prepends and appends the search term which you specify with different letters and numbers, places it into Google search box and pulls out keyword suggestions.
    type: GoogleAdsRequestTypeGq.LONG_TAIL,
    name: 'Autocomplete Ideas',
    searchHistoryName: 'Autocomplete ideas',
    shortDescription: "Adds keywords by creating new long-tail keywords from the keywords that you provide",
    moreDescription: " (i.e. prepending and appending the provided keywords with letters and numbers and then making use of the Google search box to extract keyword ideas, max 1000 keywords per seed).",
    placeholder: 'keyword A, keyword B...',
    basic: true,
  },
  {
    type: 'COMBO',
    name: 'Combination Ideas',
    searchHistoryName: '',
    shortDescription: "Adds keywords by combining groups of words into new keywords, e.g. 'colors' + 'products'",
    moreDescription: " could generate keywords such as green shoes, green pants, red shoes, red pants, ... etc.",
    placeholder: '',
    basic: false,
  },
];

export const validLongTailLanguages = [
  'Swedish',
  'English',
  'Norwegian',
  'Danish',
  'Finnish',
  'German',
];
